import Navbar from "../components/Navbar";

const Gallery = () => {
  return (
    <div className="w-full sm:w-1/2 mx-auto bg-blue-200 p-4 sm:p-8 rounded-lg shadow-lg">
      <h1 className="text-5xl text-center">Coming Soon</h1>
    </div>
  );
};

export default Gallery;
